export const ROLES = Object.freeze({
  ADMIN: 'ADMIN',
  READ: 'READ',
  UNAUTHORIZED: 'UNAUTHORIZED',
})

export const PERMISSIONS = Object.freeze({
  CREATE_BRAND: 'brands:create',
  EDIT_BRAND: 'brands:edit',
  EDIT_BRAND_PROFILE: 'brand-profile:edit',
  MANAGE_SETTINGS: 'settings:manage',
  RECOVER_PUBLICATION: 'publication:recover',
  VIEW_ASSETHUB_PROJECT: 'assethub-project:view',
  VIEW_BRAND_DETAILS: 'brand-details:view',
  VIEW_BRANDS: 'brands:view',
  VIEW_REFERENCE_LINKS: 'reference-links:view',
})

export const DEFAULT_ROLE = ROLES.UNAUTHORIZED

export const ROLE_PERMISSIONS = Object.freeze({
  [ROLES.ADMIN]: [
    PERMISSIONS.VIEW_BRANDS,
    PERMISSIONS.VIEW_BRAND_DETAILS,
    PERMISSIONS.CREATE_BRAND,
    PERMISSIONS.EDIT_BRAND,
    PERMISSIONS.EDIT_BRAND_PROFILE,
    PERMISSIONS.MANAGE_SETTINGS,
    PERMISSIONS.RECOVER_PUBLICATION,
    PERMISSIONS.VIEW_ASSETHUB_PROJECT,
    PERMISSIONS.VIEW_REFERENCE_LINKS,
  ],
  [ROLES.READ]: [
    PERMISSIONS.VIEW_BRANDS,
    PERMISSIONS.VIEW_BRAND_DETAILS,
    PERMISSIONS.EDIT_BRAND,
  ],
  [ROLES.UNAUTHORIZED]: [],
})

const ROLE_PRECEDENCE = [ROLES.ADMIN, ROLES.READ]

const normalizeGroups = (groups) =>
  (Array.isArray(groups) ? groups : [groups])
    .filter(Boolean)
    .map((group) => group.toUpperCase())

export const resolveUserRole = (memberOf = [], authorizationConfig = {}) => {
  const userGroups = new Set(normalizeGroups(memberOf))

  return (
    ROLE_PRECEDENCE.find((role) =>
      normalizeGroups(authorizationConfig[role]).some((group) =>
        userGroups.has(group),
      ),
    ) || DEFAULT_ROLE
  )
}

export const hasPermission = (role, permission) =>
  ROLE_PERMISSIONS[role]?.includes(permission) ?? false

export const getRoleLabel = (role) =>
  role
    .toLowerCase()
    .split('_')
    .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`)
    .join(' ')
